
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"50","viewBox":"0 0 21 50","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.3536 45.8536C20.5488 45.6583 20.5488 45.3417 20.3536 45.1464L17.1716 41.9645C16.9763 41.7692 16.6597 41.7692 16.4645 41.9645C16.2692 42.1597 16.2692 42.4763 16.4645 42.6716L19.2929 45.5L16.4645 48.3284C16.2692 48.5237 16.2692 48.8403 16.4645 49.0355C16.6597 49.2308 16.9763 49.2308 17.1716 49.0355L20.3536 45.8536ZM0.5 0V40.5H1.5V0H0.5ZM6 46H20V45H6V46ZM0.5 40.5C0.5 43.5376 2.96243 46 6 46V45C3.51472 45 1.5 42.9853 1.5 40.5H0.5Z"}})])
          )
        }
      }
    